import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { connectSortBy } from 'react-instantsearch-dom';
import { Select } from '@grandvisionhq/forms';
import { useIntl } from '@grandvisionhq/state';

const SortBy = ({ items: items1 , refine  })=>{
    const { getLabel  } = useIntl();
    const getItemLabel = (item)=>{
        return item.label ? item.label : item.labelKey ? getLabel(item.labelKey) : undefined;
    };
    const selectOptions = items1.reduce((items, item)=>{
        const label = getItemLabel(item);
        if (!label) {
            return items;
        }
        return swcHelpers.objectSpread({}, items, {
            [label]: label
        });
    }, {});
    const handleChange = (newValue)=>{
        const item1 = items1.find((item)=>{
            const label = getItemLabel(item);
            return label === newValue;
        });
        if (item1) {
            refine(item1.value);
        }
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: "search-sort",
        "data-t": "search-sort"
    }, /*#__PURE__*/ React.createElement(Select, {
        id: "search-sort",
        name: "search-sort",
        label: getLabel('search.results.sort.sortBy'),
        options: selectOptions,
        required: false,
        onChange: handleChange,
        renderInline: true
    }));
};
var SortBy$1 = connectSortBy(SortBy);

export { SortBy, SortBy$1 as default };
//# sourceMappingURL=SortBy.js.map
